module.exports = __webpack_public_path__ + "img/sxy_banner.926514ba.png";